const notifications = {
    addToDesktop: {
        description: "Simgemizi masaüstünüze ekleyin: Paylaş'a tıklayın ve Ana Ekrana Git'i seçin",
        button: 'Anlaşılır',
    },
};

export default notifications;
